module.exports = __webpack_public_path__ + "static/media/vegitables_77.3ebb60f4.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_77.csv
// module id = 665
// module chunks = 0